const OTA_URL =
  process.env.REACT_APP_OTA_URL || process.env.REACT_APP_CUSTOMER_URL || "";

const LOCAL_CUSTOMER_ROOT = "http://localhost:3000";

const isLocalHost = (hostname = "") =>
  ["localhost", "127.0.0.1", "::1"].includes(hostname.toLowerCase());

const configuredOtaRoot = () => OTA_URL.replace(/\/$/, "");

const currentOriginRoot = () => {
  if (typeof window === "undefined") return "";

  const { protocol, hostname } = window.location;
  if (isLocalHost(hostname)) return "";

  const labels = hostname.toLowerCase().split(".");
  const vooclyIndex = labels.lastIndexOf("voocly");
  if (vooclyIndex < 0 || labels[vooclyIndex + 1] !== "com") {
    return window.location.origin;
  }

  const prefix = labels.slice(0, vooclyIndex).join(".");
  const root = labels.slice(vooclyIndex).join(".");

  if (prefix === "partner-qa" || prefix === "api-qa") {
    return `${protocol}//qa.${root}`;
  }

  return `${protocol}//${root}`;
};

const otaRoot = () => configuredOtaRoot() || currentOriginRoot() || LOCAL_CUSTOMER_ROOT;

/**
 * Returns the public-facing URL for a supplier's shop.
 *
 * Dev  (OTA_URL contains localhost):
 *   http://localhost:3000/dev/shop/{handle}
 *
 * Production (OTA_URL is a real domain, e.g. https://voocly.com):
 *   https://{handle}.voocly.com
 */
export const publicShopUrl = (handle = "", search = "") => {
  const cleanHandle = String(handle || "").replace(/^@+/, "");
  const cleanSearch = search ? (search.startsWith("?") ? search : `?${search}`) : "";

  const base = otaRoot();

  // Dev: path-based route so no subdomain DNS needed locally
  try {
    const url = new URL(base);
    if (isLocalHost(url.hostname)) {
      return `${url.origin}/dev/shop/${cleanHandle}${cleanSearch}`;
    }
  } catch {
    // Continue to the production fallback below. A malformed configured URL
    // must not send production users to localhost.
  }

  // Production: subdomain per supplier  (https://handle.voocly.com)
  try {
    const { protocol, hostname } = new URL(base);
    return `${protocol}//${cleanHandle}.${hostname}${cleanSearch}`;
  } catch {
    return `https://${cleanHandle}.voocly.com${cleanSearch}`;
  }
};

export const publicActivityUrl = (identifier = "") => {
  const cleanIdentifier = encodeURIComponent(String(identifier || "").trim());
  return `${otaRoot()}/activity/${cleanIdentifier}`;
};

/** Identifies partner product previews in page URLs and analytics attribution. */
export const partnerPreviewActivityUrl = (identifier = "") => {
  const url = new URL(publicActivityUrl(identifier));
  url.searchParams.set("preview", "partner");
  url.searchParams.set("utm_source", "partner_portal");
  url.searchParams.set("utm_medium", "preview");
  url.searchParams.set("utm_campaign", "product_preview");
  return url.toString();
};
